import { Controller } from "@hotwired/stimulus";

export default class OauthController extends Controller {
  connect() {
    this.tabId = sessionStorage.getItem('auth_sync_tab_id');

    if (!this.tabId) {
      this.tabId = crypto.randomUUID();
      sessionStorage.setItem('auth_sync_tab_id', this.tabId);
    }

    this.handleOAuthMessage = (event) => {
      if (event.origin !== globalThis.location.origin) return;

      if (event.data?.success === true) {
        globalThis.location.reload();
      }
    };

    globalThis.addEventListener("message", this.handleOAuthMessage);
  }

  call(event) {
    event.preventDefault();

    this.submitPost(event.currentTarget.href);
  }

  submitPost(url) {
    const form = document.createElement("form");

    form.method = "POST";
    form.action = url;
    form.dataset.turbo = false;

    const csrfToken = document.querySelector(
      "meta[name=\"csrf-token\"]"
    )?.content;

    if (csrfToken) {
      const csrfInput = document.createElement("input");

      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrfToken;

      form.appendChild(csrfInput);
    }

    document.body.appendChild(form);
    form.requestSubmit();
  }

  signInWithGoogle(event) {
    event.preventDefault();
    const isSmallScreen = globalThis.screen.availWidth <= 768;

    const width = isSmallScreen
      ? globalThis.screen.availWidth
      : Math.min(Math.round(globalThis.screen.availWidth * 0.4), 600);

    let height = isSmallScreen
      ? globalThis.screen.availHeight
      : Math.min(Math.round(globalThis.screen.availHeight * 0.8), 800);

    height = height - (height * 30 / 100);

    const left = isSmallScreen
      ? 0
      : globalThis.screenX + (globalThis.outerWidth - width) / 2;

    const top = isSmallScreen
      ? 0
      : globalThis.screenY + (globalThis.outerHeight - height) / 2;

    // Open popup
    globalThis.open(
      "",
      "google-login",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );

    // Create form
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/users/auth/google_oauth2";
    form.target = "google-login";

    // CSRF token
    const token = document.querySelector("meta[name=\"csrf-token\"]").content;

    const csrf = document.createElement("input");
    csrf.type = "hidden";
    csrf.name = "authenticity_token";
    csrf.value = token;
    form.appendChild(csrf);

    // Current browser tab ID
    const tabId = document.createElement('input');
    tabId.type = 'hidden';
    tabId.name = 'auth_sync_tab_id';
    tabId.value = this.tabId;
    form.appendChild(tabId);

    document.body.appendChild(form);
    form.submit();
    form.remove();
  }

  disconnect() {
    globalThis.removeEventListener("message", this.handleOAuthMessage);
  }
}
